module.exports = __webpack_public_path__ + "static/texas-sunset-14c0756fb5f5e0c63de10b21b9ae6566.jpg";